// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"01579706","656":"ed2fb95c","765":"8b1c315e"}[chunkId] + ".chunk.css";
};